import { PERMISSIONS, type Permission } from '@/shared/constants';

export const ADDON_BUY_PERMISSIONS = new Set<Permission>([
	PERMISSIONS.ALERTS_BUY,
	PERMISSIONS.CONCILIATION_BUY,
	PERMISSIONS.POS_PERSONALIZATION_BUY,
	PERMISSIONS.REPORT_BUY,
]);

export const ADDON_PERMISSION_MAP: Record<string, Permission> = {
	alerts: PERMISSIONS.ALERTS_BUY,
	conciliations: PERMISSIONS.CONCILIATION_BUY,
	personalization: PERMISSIONS.POS_PERSONALIZATION_BUY,
	reports: PERMISSIONS.REPORT_BUY,
};

export const ADDON_API_LABEL_MAP: Record<string, string> = {
	pos_personalization: 'personalization',
	'reports:schedule': 'reports',
};
